import { Foreground, Background, Stroke, BorderSize } from '@front/sharedcomponents/Styles';
export var ToggleButtonType;
(function (ToggleButtonType) {
    ToggleButtonType["Secondary"] = "secondary";
})(ToggleButtonType || (ToggleButtonType = {}));
export const ToggleButtonTypeClass = {
    [ToggleButtonType.Secondary]: `${Background.Secondary}  ${Foreground.Secondary} ${Stroke.General} ${BorderSize.Solid1}`
};
export const CheckedToggleButtonTypeClass = {
    [ToggleButtonType.Secondary]: `${Background.Primary} ${Foreground.Primary} ${Stroke.General} ${BorderSize.Solid1}`
};
